import React from 'react';
import styles from './PageHeader.module.scss';

const PageHeader = (props) => {

  return (

    <div className={styles.PageHeader}>
      <div className="page-header">
        <h1 className="page-title">{props.titles}</h1>
      </div>
    </div>
  )
};

export default PageHeader;
